<label [for]="id" class="text-sm/6 font-medium text-gray-900 inline-flex gap-x-1">
  {{ label }}{{ required ? '*' : '' }}
  @if (isValid && validationPattern) {
    <span class="icon-[ph--check] text-green-700 place-self-center"></span>
  } @else if (!isValid && validationPattern) {
    <span class="icon-[ph--x] text-red-700 place-self-center"></span>
  }
</label>
<div class="mt-2">
  <div class="inline-flex w-full">
    <div [ngClass]="{'rounded-r-none': hasButton}"
         class="w-full flex items-center rounded-md bg-white pl-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within-outline">
      @if (hasContent) {
        <div class="hidden md:block shrink-0 text-base text-gray-500 sm:text-sm/6 select-none font-thin">
          <ng-content></ng-content>
        </div>
      }
      <input (ngModelChange)="onChange($event)" [autocomplete]="autocomplete"
             [id]="id"
             [name]="name"
             [ngModel]="value" [placeholder]="placeholder"
             [attr.aria-describedby]="hintId"
             [readOnly]="readonly" [type]="type"
             class="block min-w-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6"/>
    </div>
    @if (hasButton) {
      <button (click)="clicked.emit()"
              class="-mx-px whitespace-nowrap text-nowrap rounded-r-md bg-white px-3 py-1.5 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:!bg-gray-200"
              type="button">
        {{ buttonText }}
      </button>
    }
  </div>
</div>
@if (hint()) {
  <p [id]="hintId" class="mt-2 text-xs text-gray-500">{{ hint() }}</p>
}
